module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "manage_app p_background clearfix"
  }, [_c('h3', {
    staticClass: "all_title",
    attrs: {
      "id": "top_title"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "table_box user-select clearfix container_box"
  }, [_c('div', {
    staticClass: "basic_container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudServiceSchool.schoolName),
      expression: "tCloudServiceSchool.schoolName"
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "school_name",
      "maxlength": "30",
      "name": "yymc"
    },
    domProps: {
      "value": (_vm.tCloudServiceSchool.schoolName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudServiceSchool, "schoolName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip_sub_text text_margin_left"
  })]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudServiceSchool.schoolUrl),
      expression: "tCloudServiceSchool.schoolUrl"
    }],
    staticClass: "form-control form_control",
    attrs: {
      "type": "text",
      "id": "school_ip",
      "maxlength": "40",
      "name": "yymc"
    },
    domProps: {
      "value": (_vm.tCloudServiceSchool.schoolUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudServiceSchool, "schoolUrl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip_sub_text text_margin_left"
  })]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudServiceSchool.addressProvince),
      expression: "tCloudServiceSchool.addressProvince"
    }],
    staticClass: "form-control form_control form_select",
    attrs: {
      "name": "",
      "id": "register_addressprovince"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudServiceSchool, "addressProvince", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.queryProvinceCity('0', '0', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.provinceOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.dictionaryname) + "\n\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudServiceSchool.addressCity),
      expression: "tCloudServiceSchool.addressCity"
    }],
    staticClass: "form-control form_control form_select",
    attrs: {
      "name": "",
      "id": "register_addresscity"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudServiceSchool, "addressCity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.queryProvinceCity('0', '1', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.cityOptions), function(cityoption) {
    return _c('option', {
      domProps: {
        "value": cityoption.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(cityoption.dictionaryname) + "\n\t\t\t\t\t")])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudServiceSchool.addressCounty),
      expression: "tCloudServiceSchool.addressCounty"
    }],
    staticClass: "form-control form_control form_select",
    attrs: {
      "name": "",
      "id": "register_addressstreet"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tCloudServiceSchool, "addressCounty", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.queryProvinceCity('0', '2', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _vm._l((_vm.streetOptions), function(streetoption) {
    return _c('option', {
      domProps: {
        "value": streetoption.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(streetoption.dictionaryname) + "\n\t\t\t\t\t")])
  })], 2)]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudServiceSchool.androidDownload),
      expression: "tCloudServiceSchool.androidDownload"
    }],
    staticClass: "form-control form_control",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "type": "text",
      "id": "android_url",
      "maxlength": "400",
      "name": "yymc"
    },
    domProps: {
      "value": (_vm.tCloudServiceSchool.androidDownload)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudServiceSchool, "androidDownload", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip_sub_text text_margin_left"
  })]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tCloudServiceSchool.iosDownload),
      expression: "tCloudServiceSchool.iosDownload"
    }],
    staticClass: "form-control form_control",
    staticStyle: {
      "width": "428px"
    },
    attrs: {
      "type": "text",
      "id": "ios_url",
      "maxlength": "400",
      "name": "yymc"
    },
    domProps: {
      "value": (_vm.tCloudServiceSchool.iosDownload)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tCloudServiceSchool, "iosDownload", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tip_sub_text text_margin_left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn_box text-center partition_message"
  }, [_c('span', {
    staticClass: "btn btn_submit",
    attrs: {
      "id": "save_app_btn"
    },
    on: {
      "click": function($event) {
        return _vm.doSubmit($event)
      }
    }
  }, [_vm._v("确认" + _vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "btn btn_submit",
    attrs: {
      "id": "inspect_app_btn"
    },
    on: {
      "click": function($event) {
        return _vm.doSubmit($event)
      }
    }
  }, [_vm._v("取消")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("学校名称：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("学校URL：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("学校地址：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("android应用下载地址：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_c('i', {
    staticClass: "must_color"
  }, [_vm._v("*")]), _vm._v("IOS应用下载地址：")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-732a4064"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/schoolinfo_edit.vue
// module id = 1265
// module chunks = 1